import React, {PropsWithChildren} from 'react';
import {QueryClient, QueryClientProvider} from 'react-query';
import {ReactQueryDevtools} from 'react-query/devtools';

const client = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
		},
	},
});

export type QueryProviderProps = PropsWithChildren<{
	optimized?: boolean;
	position?: 'top-right' | 'bottom-right' | 'top-left' | 'bottom-left';
}>;

export const QueryProvider = ({optimized, children, position = 'bottom-left'}: QueryProviderProps) => {
	const items = [children];

	if (!optimized) items.push(React.createElement(ReactQueryDevtools, {key: 'rdt', position}));

	return React.createElement(QueryClientProvider, {client}, items);
};
